// extracted by mini-css-extract-plugin
export var largeWrapper = "eye_catch-module--largeWrapper--1yONQ";
export var largeIcon = "eye_catch-module--largeIcon--1bn02";
export var mediumWrapper = "eye_catch-module--mediumWrapper--55Eqk";
export var smallWrapper = "eye_catch-module--smallWrapper--hRuyV";
export var mediumIcon = "eye_catch-module--mediumIcon--3ux7J";
export var smallIcon = "eye_catch-module--smallIcon--ocqqZ";